import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { DIRECTION_TYPES, JALUZI_SISTEM_TIPLERI } from '../../../../constants';
import { formatPrice } from '../../../../utils';
import { handleNumericKeyDown, customSelectStyles } from '../OrderFormUtils';
import OrderMotorSection from './OrderMotorSection';

const JaluziForm = ({
  newOrder,
  onFieldChange,
  isLoading,
  productItems,
  productOptions,
  handleProductSelect,
  adminSettings,
  selectedProductType,
  handleMotorTypeChange
}) => {
  return (
    <>
      <div className="form-group">
        <label>Oda Adı *</label>
        <input type="text" value={newOrder.roomName || ''} onChange={(e) => onFieldChange('roomName', e.target.value)} required disabled={isLoading} />
      </div>
      <div className="form-group">
        <label>Ürün Adı *</label>
        <CreatableSelect
          options={productOptions}
          value={
            productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
            (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
          }
          onChange={(option) => {
            if (!option) {
              onFieldChange('productName', '');
              onFieldChange('unitPrice', '');
              onFieldChange('baseUnitPrice', '');
            } else if (option.__isNew__) {
              onFieldChange('productName', option.value);
              onFieldChange('unitPrice', '');
              onFieldChange('baseUnitPrice', '');
            } else {
              handleProductSelect(option.value);
            }
          }}
          isDisabled={isLoading}
          isClearable
          isSearchable
          placeholder="Ürün seçin veya yazın..."
          noOptionsMessage={() => "Ürün bulunamadı"}
          formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
          styles={customSelectStyles}
        />
      </div>
      <div className="form-group">
        <label>Ürün Varyantı</label>
        <input
          type="text"
          value={newOrder.productVariant || ''}
          onChange={(e) => onFieldChange('productVariant', e.target.value)}
          disabled={isLoading}
          placeholder="Renk, desen vb. giriniz..."
        />
      </div>

      {selectedProductType === 'ahsapJaluzi' && (
        <div className="form-group">
          <label>Sistem Tipi *</label>
          <Select
            options={Object.entries(JALUZI_SISTEM_TIPLERI).map(([key, value]) => ({ value: value, label: value }))}
            value={newOrder.sistemTipi ? { value: newOrder.sistemTipi, label: newOrder.sistemTipi } : null}
            onChange={(option) => {
              const selectedSys = option ? option.value : '';
              onFieldChange('sistemTipi', selectedSys);
              const currentProduct = productItems.find(p => p.name === newOrder.productName);
              let newPrice = newOrder.unitPrice;
              if (currentProduct) {
                if (selectedSys === JALUZI_SISTEM_TIPLERI.merdivenIpli) newPrice = currentProduct.merdivenIpliFiyat || '';
                else if (selectedSys === JALUZI_SISTEM_TIPLERI.kurdeleli) newPrice = currentProduct.kurdeleliFiyat || '';
                else if (selectedSys === JALUZI_SISTEM_TIPLERI.merdivenIpliReduktorlu) newPrice = currentProduct.merdivenIpliReduktorluFiyat || '';
                else if (selectedSys === JALUZI_SISTEM_TIPLERI.kurdelaliReduktorlu) newPrice = currentProduct.kurdelaliReduktorluFiyat || '';
                else newPrice = currentProduct.merdivenIpliFiyat || currentProduct.kurdeleliFiyat || currentProduct.merdivenIpliReduktorluFiyat || currentProduct.kurdelaliReduktorluFiyat || '';
                
                onFieldChange('baseUnitPrice', newPrice);
                onFieldChange('unitPrice', Number(newPrice));
              }
            }}
            isDisabled={isLoading} isClearable isSearchable placeholder="Sistem Tipi Seçin" noOptionsMessage={() => "Sistem Tipi bulunamadı"} styles={customSelectStyles}
          />
        </div>
      )}

      <div className="form-group">
        <label>Birim Fiyat (€) *</label>
        <input
          type="number"
          step="0.01"
          min="0"
          value={newOrder.unitPrice || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => {
            const value = e.target.value;
            if (value === '') {
              onFieldChange('unitPrice', '');
              onFieldChange('baseUnitPrice', '');
              return;
            }
            const reduktorExtra = newOrder.hasMetalReduktor ? (Number(adminSettings.metalReduktorPrice) || 0) : 0;
            const numVal = parseFloat(value);
            const base = Number.isNaN(numVal) ? value : Math.max(0, numVal - reduktorExtra);
            onFieldChange('unitPrice', value);
            onFieldChange('baseUnitPrice', base);
          }}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>En (cm) *</label>
        <input type="number" step="0.01" onKeyDown={handleNumericKeyDown} value={newOrder.width || ''} onChange={(e) => onFieldChange('width', e.target.value)} required disabled={isLoading} />
      </div>
      <div className="form-group">
        <label>Boy (cm) *</label>
        <input type="number" step="0.01" onKeyDown={handleNumericKeyDown} value={newOrder.height || ''} onChange={(e) => onFieldChange('height', e.target.value)} required disabled={isLoading} />
      </div>
      {newOrder.width && newOrder.usedM2 && (
        <div className="form-group">
          <label>Kullanılan Mt²</label>
          <input type="text" value={newOrder.usedM2} readOnly className="readonly-field" />
        </div>
      )}

      <div className="form-group">
        <label>Yön *</label>
        <select value={newOrder.direction || ''} onChange={(e) => onFieldChange('direction', e.target.value)} required disabled={isLoading}>
          <option value="">Seçiniz</option>
          {Object.entries(DIRECTION_TYPES).map(([key, value]) => (<option key={key} value={value}>{value}</option>))}
        </select>
      </div>
      <OrderMotorSection
        newOrder={newOrder}
        onFieldChange={onFieldChange}
        adminSettings={adminSettings}
        selectedProductType={selectedProductType}
        isLoading={isLoading}
      />
      <div className="form-group">
        <label>Montaj (€)</label>
        <input type="number" step="0.01" value={newOrder.mounting || ''} onChange={(e) => onFieldChange('mounting', e.target.value)} disabled={isLoading} />
      </div>

      {selectedProductType === 'ahsapJaluzi' && (
        <div className="form-group">
          <label>&nbsp;</label>
          <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
            <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasZigil || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasZigil', checked); onFieldChange('zigilAmount', checked ? adminSettings.zigilPrice : 0); }} />
            <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Ahşap Zıgıl Sistemi</span>
          </label>
        </div>
      )}

      {selectedProductType === 'metalJaluzi' && (
        <>
          <div className="form-group">
            <label>&nbsp;</label>
            <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
              <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasMetalZigil || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasMetalZigil', checked); onFieldChange('metalZigilAmount', checked ? adminSettings.metalZigilPrice : 0); }} />
              <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Zıgıl Sistem Telli Takım</span>
            </label>
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
              <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasMetalReduktor || false} onChange={(e) => {
                const checked = e.target.checked;
                onFieldChange('hasMetalReduktor', checked);
                const hasBase = newOrder.baseUnitPrice !== undefined && newOrder.baseUnitPrice !== null && newOrder.baseUnitPrice !== '';
                const base = hasBase ? (Number(newOrder.baseUnitPrice) || 0) : (Number(newOrder.unitPrice) || 0);
                if (!hasBase) onFieldChange('baseUnitPrice', base);
                const extraRed = checked ? (Number(adminSettings.metalReduktorPrice) || 0) : 0;
                onFieldChange('unitPrice', base + extraRed);
              }} />
              <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Redüktörlü Perde Farkı (m2)</span>
            </label>
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <label style={{ display: 'flex', alignItems: 'center', height: '42px', padding: '0 12px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%', backgroundColor: '#f8fafc', cursor: 'pointer', margin: 0, transition: 'all 0.2s ease' }}>
              <input type="checkbox" style={{ width: '16px', height: '16px', marginRight: '10px', cursor: 'pointer', accentColor: '#b04309' }} checked={newOrder.hasIkiCamArasi || false} onChange={(e) => { const checked = e.target.checked; onFieldChange('hasIkiCamArasi', checked); onFieldChange('ikiCamArasiAmount', checked ? adminSettings.ikiCamArasiPrice : 0); }} />
              <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>İki Cam Arası Buton Sistem Takım</span>
            </label>
          </div>
        </>
      )}

      <div className="form-group">
        <label>Adet *</label>
        <input
          type="number"
          min="1"
          value={newOrder.quantity || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('quantity', e.target.value)}
          required
          disabled={isLoading}
          placeholder="Adet giriniz"
        />
      </div>

      <div className="form-group">
        <label>İskonto (%)</label>
        <input
          type="number"
          min="0"
          max="100"
          value={newOrder.discount || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('discount', e.target.value)}
          disabled={isLoading}
        />
      </div>

      {newOrder.productName && (
        <div className="form-group">
          <label>Toplam Tutar (€)</label>
          <input
            type="text"
            value={formatPrice(newOrder.totalPrice)}
            readOnly
            className="readonly-field total-price"
          />
        </div>
      )}

      {newOrder.discount > 0 && (
        <div className="form-group">
          <label>İndirimli Tutar (€)</label>
          <input
            type="text"
            value={formatPrice(newOrder.discountedPrice)}
            readOnly
            className="readonly-field discounted-price"
          />
        </div>
      )}

    </>
  );
};

export default JaluziForm;
